import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { Form,Tabs,DatePicker, message,Tag	 } from 'antd';
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicButton from "../../components/frame/DynamicButton";
import ReactAbstract from "../../components/abstract/React.abstract";
import myAttendance from "../../services/Employee/my-attendance-service";
import { push } from 'react-router-redux';
import { store } from '../../store/store.js';


class MyAttendance extends ReactAbstract {
	
	deleteRowSelection = true
	dataMode = 1
	initReload = false
	moduleName = "attendance"
	childModuleName = "myAttendance"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		filters: {
			page: 1
		},
		data: [],
		dataStatus: "unload",
		tabIndex: "selectAttendanceAction"
	}

	actions = {
		selectAttendanceAction: myAttendance.fetchMyAttendanceList,
		selectMyAttendanceAction: myAttendance.fetchMyAttendanceRecords,
		selectLeaveAttendanceAction: myAttendance.fetchLeaveRecords,
		selectOvertimeAttendanceAction: myAttendance.fetchOvertimeRecords,
		selectBreakdownAttendanceAction: myAttendance.fetchBreakdownAttendance
	}

	componentWillMount() {
		if ("loaded" !== this.state.dataStatus || this.initReload) {
			this.publicSelect();
		}
	}

	publicSelect = () => {
		let gets = {}
		Object.keys(this.state.filters).forEach(key => {
			if (this.state.filters[key]) {
				gets[key] = this.state.filters[key];
			}
		});
		let apoLoadStatus = false;
		this.actions[this.state.tabIndex](gets, res => {
			if(res.data.Success){
				apoLoadStatus = true;
				this.setState({
					dataStatus: "loaded",
					data: this.dataMode === 1 ? res.data.Object : res.data
				})
			}
			else{
				message.error(res.data.Errors[0])
			}
			
		}, err => this.setState({dataStatus: "error"}))
		let timeoutIndex = setTimeout(() => {
			clearTimeout(timeoutIndex);
			if (!apoLoadStatus) {
				this.setState({dataStatus: "loading"})
			}
		}, 100)
	}

	handleDatePickerStartChange = (val) => this.publicChange({search_start_time : val&&val.format("YYYY-MM-DD")})
	handleDatePickerEndChange = (val) => this.publicChange({search_end_time : val&&val.format("YYYY-MM-DD")})
	handleMonthPickerStartChange = (val) => this.publicChange({search_start_time : val&&val.format("YYYY-MM")})
	handleMonthPickerEndChange = (val) => this.publicChange({search_end_time : val&&val.format("YYYY-MM")})

	buttonColumn = (text, record, index) => [{
			size: "small",
			type: "default",
			icon: "edit",
			title: "详情",
			access: "u_value",
			click: () => store.dispatch(push("/employee/my-attendance-detail/"+record.management_date))
		}
	]

	tableColumn = {
		selectAttendanceAction: [
			{title: <div><div>部门</div><div>Department</div></div>, key: "department_name", dataIndex: "department_name", className: 'table-global-head'},
			{title: <div><div>日期</div><div>Date</div></div>, key: "record_date", dataIndex: "record_date", className: 'table-global-head-short'},
			{title: <div><div>星期</div><div>Weekday</div></div>, key: "record_date_weekday", dataIndex: "record_date_weekday", className: 'table-global-head-5x'},
			{title: <div><div>班次</div><div>Classes</div></div>, key: "sequence_time", dataIndex: "sequence_time", className: 'table-attendance-head'},
			{title: <div><div>实际开始时间</div><div>On Time</div></div>, key: "on_time", dataIndex: "on_time", className: 'table-global-head'},
			{title: <div><div>实际结束时间</div><div>Off time</div></div>, key: "off_time", dataIndex: "off_time", className: 'table-global-head'},
			{title: <div><div>迟到</div><div>Late</div></div>, key: "late_hours", dataIndex: "late_hours", className: 'table-global-head-tiny'},
			{title: <div><div>早退</div><div>Early Exit</div></div>, key: "early_exit_hours", dataIndex: "early_exit_hours", className: 'table-global-head-5x'},
			{title: <div><div>加班</div><div>Overtime</div></div>, key: "normal_overtimes", dataIndex: "normal_overtimes", className: 'table-global-head-5x'},
			{title: <div><div>调休</div><div>Relaxation</div></div>, key: "normal_relaxation", dataIndex: "normal_relaxation", className: 'table-global-head-5x'},
			// {title: <div><div>请假</div><div>Leave</div></div>, key: "leave_hours", dataIndex: "leave_hours", className: 'table-global-head-tiny'},
			{title: <div><div>事假</div><div>Leave</div></div>, key: "personal_leave_hours", dataIndex: "personal_leave_hours", className: 'table-global-head-tiny'},
			{title: <div><div>病假</div><div>Leave</div></div>, key: "sick_leave_hours", dataIndex: "sick_leave_hours", className: 'table-global-head-tiny'},
			{title: <div><div>状态</div><div>Status</div></div>, key: "tags", dataIndex: "tags", className: 'table-global-head-short',
			render: tags => (
				<span>
					{tags.map(tag => {
						if (tag) {
							let color = "";
							if (tag === '上班未打卡' || tag === '下班未打卡' || tag === '旷工' || tag === '迟到' || tag === '早退') {
								color = 'red';
							}
							return <Tag color={color} key={tag}>{tag}</Tag>;
						}
					})}
				</span>
			),
		},
			{title: <div><div>备注</div><div>Comment</div></div>, key: "remark", dataIndex: "remark", className: 'table-global-head'},
			// {title: "操作", key: "action", dataIndex: "action", className: 'table-global-head'}
		],
		selectMyAttendanceAction: [
			{title: <div><div>月份</div><div>Month</div></div>, key: "management_date", dataIndex: "management_date", className: 'table-global-head-short'},
			{title: <div><div>应出勤(天)</div><div>Should</div><div>Attendance</div><div>(Day)</div></div>, key: "should_attendance_count", dataIndex: "should_attendance_count", className: 'table-global-head-5x'},
			{title: <div><div>实际出勤(天)</div><div>Actual</div><div>Attendance</div><div>(Day)</div></div>, key: "actual_attendance_count", dataIndex: "actual_attendance_count", className: 'table-global-head-6x'},
			// {title: <div><div>缺勤(天)</div><div>Absenteeism</div><div>(Day)</div></div>, key: "missing_attendance_count", dataIndex: "missing_attendance_count", className: 'table-global-head-6x'},
			{title: <div><div>迟到(次)</div><div>Late(Time)</div></div>, key: "late_count", dataIndex: "late_count", className: 'table-global-head-5x'},
			{title: <div><div>早退(次)</div><div>Early</div><div>Exit(Time)</div></div>, key: "leave_early_count", dataIndex: "leave_early_count", className: 'table-global-head-5x'},
			{title: <div><div>考勤遗漏(次)</div><div>Attendance</div><div>Lose(Time)</div></div>, key: "attendance_lose", dataIndex: "attendance_lose", className: 'table-global-head-6x'},
			// {title: <div><div>请假(小时)</div><div>Leave(Hour)</div></div>, key: "qingjia_hours", dataIndex: "qingjia_hours", className: 'table-global-head-6x'},
			{title: <div><div>事假(小时)</div><div>Personal_Leave(Hour)</div></div>, key: "personal_leave_count", dataIndex: "personal_leave_count", className: 'table-global-head-6x'},
			{title: <div><div>病假(小时)</div><div>Sick_Leave(Hour)</div></div>, key: "sick_count", dataIndex: "sick_count", className: 'table-global-head-6x'},
			{title: <div><div>加班(小时)</div><div>Overtime(Hour)</div></div>, key: "overtime_hours", dataIndex: "overtime_hours", className: 'table-global-head-5x'},
			{title: <div><div>调休(小时)</div><div>Relaxation(Hour)</div></div>, key: "relaxation_hours", dataIndex: "relaxation_hours", className: 'table-global-head-5x'},
			{title: <div><div>年假(天)</div><div>Annual</div><div>Leave(Day)</div></div>, key: "year_vacation_count", dataIndex: "year_vacation_count", className: 'table-global-head-6x'},
			{title: <div><div>全勤</div><div>Full-time</div></div>, key: "all_attendance", dataIndex: "all_attendance", className: 'table-global-head-5x'},
			// {title: <div><div>操作</div><div>Action</div></div>, key: "action", dataIndex: "action", className: 'table-global-head-small',
			// 	render: (text, record, index) => (
			// 		<DynamicButton column={this.buttonColumn(text, record, index)}
			// 			module={this.childModuleName}
			// 			access={this.props.access} />
			// 	)}
		],
		selectLeaveAttendanceAction: [
			{title: <div><div>申请类型</div><div>Type</div></div>, key: "leave_type_str", dataIndex: "leave_type_str", className: 'table-global-head'},
			{title: <div><div>开始日期</div><div>Start Date</div></div>, key: "start_date_str", dataIndex: "start_date_str", className: 'table-global-head'},
			{title: <div><div>开始时间</div><div>Start Time</div></div>, key: "start_time", dataIndex: "start_time", className: 'table-global-head'},
			{title: <div><div>结束日期</div><div>End Date</div></div>, key: "end_date_str", dataIndex: "end_date_str", className: 'table-global-head'},
			{title: <div><div>结束时间</div><div>End Time</div></div>, key: "end_time", dataIndex: "end_time", className: 'table-global-head'},
			{title: <div><div>请假原因</div><div>Reason</div></div>, key: "remark", dataIndex: "remark", className: 'table-global-head'},
			{title: <div><div>审批状态</div><div>Status</div></div>, key: "approval_status_str", dataIndex: "approval_status_str", className: 'table-global-head'}
		],
		selectOvertimeAttendanceAction: [
			{title: <div><div>加班类型</div><div>Type</div></div>, key: "overtime_type_str", dataIndex: "overtime_type_str", className: 'table-global-head'},
			{title: <div><div>加班日期</div><div>Date</div></div>, key: "overtime_date_str", dataIndex: "overtime_date_str", className: 'table-global-head'},
			{title: <div><div>开始时间</div><div>Start Time</div></div>, key: "start_time", dataIndex: "start_time", className: 'table-global-head'},
			{title: <div><div>结束时间</div><div>End Time</div></div>, key: "end_time", dataIndex: "end_time", className: 'table-global-head'},
			{title: <div><div>加班时长</div><div>Overtime Hours</div></div>, key: "overtime_hours", dataIndex: "overtime_hours", className: 'table-global-head'},
			{title: <div><div>加班原因</div><div>Reason</div></div>, key: "remark", dataIndex: "remark", className: 'table-global-head'},
			{title: <div><div>审批状态</div><div>Status</div></div>, key: "approval_status_str", dataIndex: "approval_status_str", className: 'table-global-head'}
		],
		selectBreakdownAttendanceAction: [
			{title: <div><div>调休类型</div><div>Type</div></div>, key: "relaxation_type_str", dataIndex: "relaxation_type_str", className: 'table-global-head'},
			{title: <div><div>开始日期</div><div>Start Date</div></div>, key: "start_date_str", dataIndex: "start_date_str", className: 'table-global-head'},
			{title: <div><div>开始时间</div><div>Start Time</div></div>, key: "start_time", dataIndex: "start_time", className: 'table-global-head'},
			{title: <div><div>结束日期</div><div>End Date</div></div>, key: "end_date_str", dataIndex: "end_date_str", className: 'table-global-head'},
			{title: <div><div>结束时间</div><div>End Time</div></div>, key: "end_time", dataIndex: "end_time", className: 'table-global-head'},
			{title: <div><div>调休原因</div><div>Reason</div></div>, key: "remark", dataIndex: "remark", className: 'table-global-head'},
			{title: <div><div>审批状态</div><div>Status</div></div>, key: "approval_status_str", dataIndex: "approval_status_str", className: 'table-global-head'}
		]
	}

	changeTabIndex = value => this.setState({
		dataStatus: "unload",
		filters: {page: 1},
		tabIndex: value
	}, this.publicSelect)
	
	render() {
		return (
			<div className="app-module-item">
				<Tabs activeKey={this.state.tabIndex} onChange={this.changeTabIndex} animated={false}>
					{this.props.access.employeeMyAttendance.att_record_value && <Tabs.TabPane tab="考勤记录 Attendance Record" key="selectAttendanceAction">
						<div style={{width:"100%"}}>
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<span style={{marginRight:"5px"}}>日期 Date: </span>
								<DatePicker onChange={this.handleDatePickerStartChange} />
							</div>	
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<span style={{marginRight:"5px"}}> To </span>
								<DatePicker onChange={this.handleDatePickerEndChange} />
							</div>
						</div>
					</Tabs.TabPane>}
					{this.props.access.employeeMyAttendance.my_att_value && <Tabs.TabPane tab="我的考勤 My Attendance" key="selectMyAttendanceAction">
						<div style={{width:"100%"}}>
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<span style={{marginRight:"5px"}}>日期 Date: </span>
								<DatePicker onChange={this.handleMonthPickerStartChange} format="YYYY-MM" />
							</div>	
							<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
								<span style={{marginRight:"5px"}}> To </span>
								<DatePicker onChange={this.handleMonthPickerEndChange} format="YYYY-MM" />
							</div>
						</div>
					</Tabs.TabPane>}
					{this.props.access.employeeMyAttendance.leave_record_value && <Tabs.TabPane tab="请假记录 Leave Record" key="selectLeaveAttendanceAction">
					</Tabs.TabPane>}
					{this.props.access.employeeMyAttendance.overtime_record_value && <Tabs.TabPane tab="加班记录 Overtime Record" key="selectOvertimeAttendanceAction">
					</Tabs.TabPane>}
					{this.props.access.employeeMyAttendance.relax_record_value && <Tabs.TabPane tab="调休记录 Relaxtion Record" key="selectBreakdownAttendanceAction">
					</Tabs.TabPane>}
				</Tabs>
				<DynamicTable column={this.tableColumn[this.state.tabIndex]}
					dataStatus={this.dataSource().dataStatus}
					dataSource={this.dataSource().data.Data}
					pagination={{
						total: this.dataSource().data.Total,
						pageSize: this.dataSource().data.PageSize,
						current: this.dataSource().filters.page}}
					setPageFilter={this.publicChange} 

					/>
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		
	}
}

const mapDispatchToProps = {

}

MyAttendance = Form.create()(MyAttendance);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(MyAttendance));


// WEBPACK FOOTER //
// ./src/routes/Employee/MyAttendance.js